import React from 'react';
import PropTypes from 'prop-types';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';

function NavigationConfirmationModal(props) {
  const { leavePage, stayOnPage, modalConfig } = props;
  const bodyContent = (
    <div>
      <div className="callout callout__error">{modalConfig.body}</div>
      <p className="review-modal__submsg" />
    </div>
  );

  const footerButtons = (
    <div className="review-modal__options">
      <button
        type="button"
        onClick={leavePage}
        className="c-btn c-btn--secondary c-modal__button"
      >
        {modalConfig.secondaryButtonText}
      </button>
      <button
        type="button"
        onClick={stayOnPage}
        className="c-btn c-btn--default c-modal__button"
      >
        {modalConfig.primaryButtonText}{' '}
      </button>
    </div>
  );

  return (
    <PatternLibModalComponent
      show
      onHide={stayOnPage}
      customClass={'c-modal review-modal'}
      bsSize={'medium'}
      modalHeading={modalConfig.title}
      modalBody={bodyContent}
      modalFooter={footerButtons}
      modalInContainer={false}
      closeButton
    />
  );
}

NavigationConfirmationModal.propTypes = {
  content: PropTypes.shape({}),
  stayOnPage: PropTypes.func,
  leavePage: PropTypes.func,
  modalConfig: PropTypes.shape({}),
};
export default NavigationConfirmationModal;
